import { NgModule } from '@angular/core';
import { FilterFileByYearPipe } from './filter-file-by-year.pipe';
import { SanitizeHtmlPipe } from './sanitizeHtml';
import { ArraySortPipe } from './arraySortPipe';
import { ConvertMonthPipe } from './convert-month';
import { SafePipe } from './safe'
@NgModule({
    imports: [],
    declarations: [FilterFileByYearPipe, SanitizeHtmlPipe, ArraySortPipe, ConvertMonthPipe, SafePipe],
    exports: [FilterFileByYearPipe, SanitizeHtmlPipe, ArraySortPipe, ConvertMonthPipe, SafePipe]
})
export class SharePipeModule { }
